function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".poster-line-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster-line-1",
  d: "M523.89,75.65c4.55,0,8.24-1.48,8.24-3.31S528.46,69,523.91,69H136c-4.55,0-8.22,1.49-8.22,3.31s3.69,3.3,8.22,3.31Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster-line-1",
  d: "M521.42,103.78c5.91,0,10.71-1.48,10.71-3.31s-4.77-3.31-10.69-3.31H17.19c-5.91,0-10.68,1.49-10.68,3.31s4.79,3.3,10.68,3.31Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "poster-line-1",
  d: "M519.41,47.52c7,0,12.72-1.48,12.72-3.31s-5.7-3.31-12.72-3.31H261.81c-7,0-12.71,1.48-12.71,3.31s5.69,3.31,12.71,3.31Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "poster-line-1",
  d: "M523.6,19.39c4.71,0,8.53-1.48,8.53-3.3s-3.82-3.31-8.53-3.31H350.93c-4.71,0-8.52,1.48-8.52,3.31s3.81,3.3,8.52,3.3Z"
});

var SvgLines = function SvgLines(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 537.27 125.38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lines.9680ed15.svg";
export { ForwardRef as ReactComponent };